<template>
  <div class="props-group">
      <div class="private">
        <el-form-item label="水平对齐">
          <el-select v-model="component.properties.justifyContent" placeholder="请选择">
            <el-option label="居左" value="flex-start"></el-option>
            <el-option label="居中" value="center"></el-option>
            <el-option label="居右" value="flex-end"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="垂直对齐" v-if="component.type==='rc-label'">
          <el-select v-model="component.properties.alignItems" placeholder="请选择">
            <el-option label="居上" value="flex-start"></el-option>
            <el-option label="居中" value="center"></el-option>
            <el-option label="居下" value="flex-end"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否加粗" v-if="component.type==='rc-label'">
          <el-select v-model="component.properties.fontWeight" placeholder="请选择">
            <el-option label="正常" value="normal"></el-option>
            <el-option label="加粗" value="bolder"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="字体颜色" class="form-group" v-if="component.type==='rc-label'">
          <el-button class="colorSelect" @click="colorSelectOpen" v-model="component.properties.color"
                     :style="{'background-color':component.properties.color,'width':'20%','border':'none'}"/>
          <div class="color-item" v-if="isShowColorItem">
          <span v-for="(colorItem,index) in colorArr" :key="index" :style="{'background-color':colorItem}"
                @click="colorSelectClose(colorItem)"></span>
          </div>
        </el-form-item>
      </div>
  </div>
</template>
<script>
export default {
  name: 'attr-alignment',
  props: ['component'],
  data () {
    return {
      colorArr,
      isShowColorItem: false
    }
  },
  methods: {
    colorSelectOpen () {
      this.isShowColorItem = true
    },
    colorSelectClose: function colorSelectClose (colorItem) {
      this.component.properties.color = colorItem
      this.isShowColorItem = false
    }
  }
}
const colorArr = ['#000000', '#424242', '#636363', '#9C9C94', '#CEC6CE', '#EFEFEF', '#F7F7F7', '#FFFFFF',
  '#FF0000', '#FF9C00', '#FFFF00', '#00FF00', '#00FFFF', '#0000FF', '#9C00FF', '#FF00FF', '#F7C6CE',
  '#FFE7CE', '#FFEFC6', '#D6EFD6', '#CEDEE7', '#CEE7F7', '#D6D6E7', '#E7D6DE', '#E79C9C', '#FFC69C',
  '#FFE79C', '#B5D6A5', '#A5C6CE', '#9CC6EF', '#B5A5D6', '#D6A5BD', '#E76363', '#F7AD6B', '#FFD663',
  '#94BD7B', '#73A5AD', '#6BADDE', '#8C7BC6', '#C67BA5', '#CE0000', '#E79439', '#EFC631', '#6BA54A',
  '#4A7B8C', '#3984C6', '#634AA5', '#A54A7B', '#9C0000', '#B56308', '#BD9400', '#397B21', '#104A5A',
  '#085294', '#311873', '#731842', '#630000', '#7B3900', '#846300', '#295218', '#083139', '#003163',
  '#21104A', '#4A1031']
</script>

<style lang="scss">
  .private {
    border-top: 1px solid #c2c3c4;
    margin: 0 -20px;
    padding: 0 20px;
    .form-group {
      .colorSelect {
        float: right;
        line-height: 32px;
        margin: 7px 0;
      }
      .color-item {
        float: right;
        width: 100%;
        min-height: 192px;
        border: 1px solid #ccc;

        span {
          display: inline-block;
          width: 12.5%;
          height: 24px;
          float: left;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/form/componentAttr/alignment.vue